import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { getUserAccounts } from '@/services';
import type { AccountUserViewModel } from '@/models';

export const useAccountStore = defineStore('account', () => {
  const currentId = ref<number | null>(null);

  const accounts = ref<AccountUserViewModel[]>([]);

  const currentAccount = computed(() => {
    return accounts.value.find((account) => account.accountId === currentId.value);
  });
  const hasCurrentAccount = computed(() => currentId.value !== null && currentId.value !== 0);

  // UI concerns
  const isSelectorOpen = ref(false);

  function showSelector() {
    isSelectorOpen.value = true;
  }

  async function loadAccounts(forceReload: boolean = false) {
    if (accounts.value.length === 0 || forceReload) {
      console.log('Loading accounts...');
      accounts.value = await getUserAccounts();
    }

    if (accounts.value.length === 0) {
      throw new Error('No accounts found for user');
    }

    if (!hasCurrentAccount.value) {
      console.log('No current account set...');
      console.log('Usr has accounts: ', accounts.value.length);

      if (accounts.value.length === 1) {
        console.log('Setting current account to first account');
        setCurrentAccount(accounts.value[0].accountId);
      }
      else if (accounts.value.length > 1) {
        console.log('User has multiple accounts; showing selector');
        showSelector();
      }
    }
  }

  function setCurrentAccount(accountId: number) {
    currentId.value = accountId;

    if (isSelectorOpen.value) {
      isSelectorOpen.value = false;
    }
  }

  return {
    accounts,
    currentAccount,
    currentId,
    hasCurrentAccount,
    loadAccounts,
    setCurrentAccount,

    // UI concerns
    isSelectorOpen,
    showSelector,
  }
},{
  persist: {
    key: 'account',
    pick: [
      'currentId',
    ]
  }
})
